"use client";

import { CmsItemGridParameters, CmsItemParameters, CmsSlotType } from "@/data/types";
import { Checkbox, FormControlLabel, Grid, Stack, TextField, Typography } from "@mui/material";

type Props = {
  type: CmsSlotType;
  parameters: CmsItemParameters;
  setItemParameters: (parameters: CmsItemParameters) => void;
};

function isGrid(type: CmsSlotType, _parameters: CmsItemParameters): _parameters is CmsItemGridParameters {
  return type === CmsSlotType.Grid;
}

export default function CmsItemParametersEditor({ type, parameters, setItemParameters }: Props) {
  return (
    <Stack sx={{ p: 2 }} spacing={2}>
      <Typography variant="label">Slot Item Parameters</Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={parameters.hideMobile ?? false}
                onChange={(e) => setItemParameters({ ...parameters, hideMobile: e.target.checked })}
              />
            }
            label="Hide on Mobile"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={parameters.hideDesktop ?? false}
                onChange={(e) => setItemParameters({ ...parameters, hideDesktop: e.target.checked })}
              />
            }
            label="Hide on Desktop"
          />
        </Grid>
        {isGrid(type, parameters) && (
          <>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Grid Size"
                placeholder="Grid Size"
                type="number"
                value={parameters.size || 0}
                onChange={(e) => setItemParameters({ ...parameters, size: parseInt(e.target.value as any) })}
                fullWidth
              />
            </Grid>
          </>
        )}
      </Grid>
    </Stack>
  );
}
